/**
 * Causes the mqtt client to establish a connection to the broker.
 * Technically, dispatching this action will create the mqtt client.
 *
 * NB: Per design, subsequent dispatch of this creator's action, will have no effect.
 * If you want to connect again, dispatch a `reconnect` action instead
 */
export const connect = (username, password, onceCallbacks = {}, callbacks = {}) => ({
    type: MQTT_CONNECT,
    payload: { username, password, onceCallbacks, callbacks },
});
/** Causes the mqtt client to publish a message to a topic when dispatched */
export const publish = (topic, message, options, callback) => ({
    type: MQTT_PUBLISH,
    payload: { topic, message, options, callback },
});
/** Causes the mqtt client to subscribe to a topic when dispatched */
export const subscribe = (topic, handler, options) => ({
    type: MQTT_SUBSCRIBE,
    payload: { topic, handler, options },
});
/** Causes the mqtt client to unsubscribe from a topic when dispatched */
export const unsubscribe = (topic) => ({ type: MQTT_UNSUBSCRIBE, payload: { topic } });
export const reconnect = () => ({ type: MQTT_RECONNECT });
export const MQTT_CONNECT = 'MQTT_CONNECT';
export const MQTT_PUBLISH = 'MQTT_PUBLISH';
export const MQTT_SUBSCRIBE = 'MQTT_SUBSCRIBE';
export const MQTT_UNSUBSCRIBE = 'MQTT_UNSUBSCRIBE';
export const MQTT_RECONNECT = 'MQTT_RECONNECT';
